import { render, staticRenderFns } from "./MenuBottomCat.vue?vue&type=template&id=abe9f0e8&scoped=true&"
import script from "./MenuBottomCat.vue?vue&type=script&lang=js&"
export * from "./MenuBottomCat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe9f0e8",
  null
  
)

export default component.exports